export default "__VITE_ASSET__C2DiGHZJ__"